import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import ArtworkGrid from "./ArtworkGrid";
import GalleryHeader from "./GalleryHeader";
import Footer from "./Footer";
import ReactMarkdown from "react-markdown";

export default function ProjectGallery({ artworks, projectDescriptions }) {
  const { year, projectName } = useParams();

  const projectArts = useMemo(() => {
    return artworks.filter(a => ((projectName === "Obras Independientes" && a.project === "") || (a.project === projectName)) && a.year === year);
  }, [artworks, year, projectName]);

  const description = projectDescriptions[projectName] || null;

  return (
    <div className="gallery">
      <GalleryHeader title={`${projectName} ${year}`} />
      
      {description && <div className="text-box"><ReactMarkdown >{description}</ReactMarkdown></div>}

      <ArtworkGrid artworks={projectArts} rowsize={500} />
      <Footer/>
    </div>
  );
}
